import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

// Register required Chart.js components
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler, // Enables the "fill" for area charts
    Legend
);

const AreaChart = ({labels, label, dataset}) => {
    // Chart data
    const data = {
        labels,
        datasets: [
            {
                label,
                data:dataset,
                backgroundColor: '#c4941a83', // Area color - same as border
                borderColor: '#c4941a', // Line color
                borderWidth: 2,
                fill: true, // Enables area fill
            },
        ],
    };

    // Chart options
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true,
                position: 'top',
            },
        },
        scales: {
            x: {
                grid: {
                    display: false,
                },
                ticks: {
                    color: '#666',
                    font: {
                        size: 12
                    }
                }
            },
            y: {
                beginAtZero: true,
                grid: {
                    color: 'rgba(0, 0, 0, 0.1)',
                    drawBorder: false,
                },
                ticks: {
                    color: '#666',
                    font: {
                        size: 12
                    },
                    callback: function(value) {
                        if (value >= 1000) {
                            return (value / 1000) + 'k';
                        }
                        return value;
                    }
                }
            },
        },
    };

    return <Line data={data} options={options} />;
};

export default AreaChart;
